// import createHistory from 'history/createBrowserHistory';

// // A singleton history object for easy API navigation
// const history = createHistory();
// export default history;

import { createBrowserHistory } from 'history';
export default createBrowserHistory();



// WEBPACK FOOTER //
// ./src/common/history.js